import { render, staticRenderFns } from "./Lhc_Ball.vue?vue&type=template&id=1cecaeba&scoped=true"
import script from "./Lhc_Ball.vue?vue&type=script&lang=js"
export * from "./Lhc_Ball.vue?vue&type=script&lang=js"
import style0 from "./Lhc_Ball.vue?vue&type=style&index=0&id=1cecaeba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cecaeba",
  null
  
)

export default component.exports